import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { requestSubmitAnswersQuiz } from "../../redux/actions/quizzesActionCreators";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EmailForm = ({
  open,
  handleClose,
  payload,
  quiz_id,
  thresholdsPayload,
}) => {
  const dispatch = useDispatch();

  let history = useHistory();
  const { isAuth } = useSelector((state) => state.user);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Doit être une adresse mail valide!")
        .max(255)
        .required("Adresse mail obligatoire!"),
    }),
    onSubmit: (values) => {
      let obj = {
        user_id: values.email,
        organization_id: localStorage.getItem("orgaId"),
        quiz_id: Number(quiz_id),
        answers: { questions: payload, usecases: thresholdsPayload },
        is_completed: true,
      };
      if (isAuth) {
        obj.entreprise_id = localStorage.getItem("orgaId");
        delete obj.organization_id;
      }
      dispatch(requestSubmitAnswersQuiz(obj, history, isAuth));
    },
  });
  const { t } = useTranslation();
  return (
    <>
      <Dialog fullWidth open={open}>
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {t("please_enter_your_email")}{" "}
            <IconButton
              onClick={handleClose}
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              error={Boolean(formik.touched.email && formik.errors.email)}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              margin="normal"
              name="email"
              onChange={formik.handleChange}
              value={formik.values.email}
              label={t("email_address")}
            />
            <Box sx={{ py: 2 }}>
              <Button
                color="secondary"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
              >
                {t("submit")}
              </Button>
            </Box>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EmailForm;
